import type { ReactNode } from 'react';
import { Outlet, useMatch } from 'react-router';
import { useIsDesktop } from '@/hooks/use-user-platform';

interface Props {
  pathname: string;
  children: ReactNode | ((isDesktop: boolean, match: boolean) => ReactNode);
}

export default function ConditionalLayout({ children, pathname }: Props) {
  const match = useMatch(pathname);
  const isDesktop = useIsDesktop();

  if (isDesktop || match) {
    if (typeof children === 'function') {
      return children(isDesktop, !!match);
    }

    return children;
  }

  return <Outlet />;
}
